import { type ReactNode } from 'react';
import { graphql, readInlineData } from 'react-relay/legacy.js';
import { FormattedNumber } from 'dibs-react-intl';
import { REWARDS_STATUS_PLATINUM } from '../../rewards2020/helpers/rewardsStatuses.ts';

import { type rewardsStatusHelper_rewards$key } from './__generated__/rewardsStatusHelper_rewards.graphql.ts';

export const canLevelUpStatus = (code: string | null = ''): boolean =>
    code !== REWARDS_STATUS_PLATINUM;

type NextRewardsData = {
    nextStatus: string;
    nextStatusCode: string;
    rewardPoints: ReactNode;
};

export const getNextRewardsData = (
    rewardsRef: rewardsStatusHelper_rewards$key
): NextRewardsData => {
    const data = readInlineData(
        graphql`
            fragment rewardsStatusHelper_rewards on TradeFirmRewards @inline {
                pointsNeededToLevelUp
                pointsToMaintainStatus
                currentProgram {
                    programInfo {
                        code
                        shortCopy
                    }
                }
                nextProgram {
                    programInfo {
                        code
                        shortCopy
                    }
                }
            }
        `,
        rewardsRef
    );

    const currentProgramInfo = data?.currentProgram?.programInfo;
    const nextProgramInfo = data?.nextProgram?.programInfo;
    const canLevelUp = canLevelUpStatus(currentProgramInfo?.code);

    let nextStatus = nextProgramInfo?.shortCopy;
    let nextStatusCode = nextProgramInfo?.code;
    // round points displays up so users don't potentially see 0 points when they have less than $0.50
    // to spend to level up
    let rewardPoints = Math.ceil(Number(data?.pointsNeededToLevelUp) || 0);

    if (!canLevelUp) {
        nextStatus = currentProgramInfo?.shortCopy;
        nextStatusCode = currentProgramInfo?.code;
        // same here re: rounding up
        rewardPoints = Math.ceil(data?.pointsToMaintainStatus || 0);
    }

    return {
        nextStatus: nextStatus || '',
        nextStatusCode: nextStatusCode || '',
        rewardPoints: <FormattedNumber value={rewardPoints} />,
    };
};
